import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ShadowDOM from 'react-shadow';
import { registry, useRegistrationListener } from '../utils/registry';
import ErrorBoundary from './ErrorBoundary';
export function Renderer({ componentId, data, additionalProps, renderFallback }) {
    const [, setForceRender] = React.useState(() => 0);
    useRegistrationListener((data) => {
        if (data.componentId === componentId) {
            setForceRender(previous => previous + 1);
        }
    });
    const RenderComponent = registry.getById(componentId)?.render;
    if (typeof RenderComponent !== 'function') {
        return renderFallback();
    }
    return (_jsx(ErrorBoundary, { renderFallback: renderFallback, children: _jsx(ShadowDOM.div, { children: _jsx(RenderComponent, { data: data, ...additionalProps }) }) }));
}
